import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  height: 280px;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  overflow: hidden;
  position: relative;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 16px;
    cursor: default;
      
      .dropdown-icon {
        height: 20px;
        width: 20px;
        cursor: pointer;
        text-align: center;
      }

      .widget-menu {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 160px;
        background: ${(props) => props.theme.colors.widget_background};
        box-shadow: ${(props) => props.theme.shadows.dropdown};
        border-radius: 12px;
        
        li {
          display: flex;
          align-items: center;
          gap: 8px;
          width: 100%;
          padding: 17px 16px;
          font-family: ManropeBold, sans-serif;
          font-size: 13px;
          line-height: 18px;
          cursor: pointer;

          button {
            display: contents;
          }
          
          &:hover {
            background: ${(props) => props.theme.colors.inactive};
          }
          
          &:first-child{
            border-radius: 12px 12px 0 0;
          }

          &:last-child{
            border-radius: 0 0 12px 12px;
          }
        }
      }
    }

  .fleet-health-container {
    cursor: default;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    min-height: 200px;
  }

  .fleet-health-container > div {
      padding: 0 !important;
  }

  .fleet-health-chart {
    display: inline-block;
    width: 75%;
    align-items: center;
    margin-top: 30px;
  }
  .fleet-health-score {
    display: inline-block;
    width: 25%;
    align-items: center;

    div {
      margin: 0 auto;
    }
  }
`;

export default { Wrapper };
